<template>
    <div
        class="file-drop-zone"
        :class="{ 'file-drop-zone--active': dragging }"
        @dragenter.prevent="dragging = true"
        @dragover.prevent="dragging = true"
        @dragleave.prevent="dragging = false"
        @drop.prevent="onDrop"
        @click="$refs.fileInput.click()"
    >
        <font-awesome-icon icon="upload" class="file-drop-zone__icon" />
        <span class="file-drop-zone__text">{{ label || $t('file_drop_zone.label') }}</span>
        <input
            ref="fileInput"
            type="file"
            class="visually-hidden"
            :accept="accept"
            :multiple="multiple"
            @change="onInputChange"
        />
    </div>
</template>

<script>
export default {
    name: 'FileDropZone',
    props: {
        accept: { type: String, default: null },
        multiple: { type: Boolean, default: true },
        label: { type: String, default: null }
    },
    emits: ['filesSelected'],
    data() {
        return { dragging: false }
    },
    methods: {
        onDrop(event) {
            this.dragging = false
            const accepted = this.accept ? this.accept.split(',').map(t => t.trim()) : null
            const files = Array.from(event.dataTransfer.files).filter(f => {
                if (!accepted) return true
                return accepted.some(type => {
                    if (type.startsWith('.')) return f.name.toLowerCase().endsWith(type.toLowerCase())
                    if (type.endsWith('/*')) return f.type.startsWith(type.slice(0, -1))
                    return f.type === type || f.type === type.replace('image/jpg', 'image/jpeg')
                })
            })
            if (files.length) this.$emit('filesSelected', files)
        },
        onInputChange(event) {
            const files = Array.from(event.target.files)
            if (files.length) this.$emit('filesSelected', files)
            event.target.value = ''
        }
    }
}
</script>

<style scoped>
.file-drop-zone {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    border: 2px dashed #ced4da;
    border-radius: 6px;
    padding: 16px;
    cursor: pointer;
    transition: border-color 0.15s, background 0.15s;
    color: #6c757d;
    font-size: 0.85rem;
    user-select: none;
}

.file-drop-zone:hover,
.file-drop-zone--active {
    border-color: #7FC000;
    background: #f6ffe6;
    color: #4a7a00;
}

.file-drop-zone__icon {
    font-size: 1.4rem;
    opacity: 0.6;
}
</style>
